import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Box, lighten, useTheme } from '@material-ui/core';
import { TermsType } from 'typings/markets/api';
import { useTranslation } from 'next-i18next';
import Spacer from '@/components/ui-components/Spacer';
import Typography from '../../components/Typography';
import useTermsFormat from './useTermsFormat';

interface StyleProps {
  bg: string;
  fg: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: ({ bg }: StyleProps) => bg,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    borderRadius: '8px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(-2),
      marginRight: theme.spacing(-2),
    },
  },
  termTitle: {
    color: ({ fg }: StyleProps) => fg,
    fontWeight: theme.typography.fontWeightBold,
  },
  termValueText: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

/* export interface SecurityType {
  terms: {
    title: string;
    value: string | number;
  }[];
  bottomText?: string;
} */

export type TermType = 'SAFE' | 'EQUITY' | 'DEBT' | 'CONVERTIBLE' | 'REVENUE_SHARING'| 'OTHER' | 'UNKNOWN';

interface Props {
  // security: SecurityType;
  name: TermType
  term: TermsType['standard'] | TermsType['converts_to']
  currency: string
}

const defaultProps = {};

const SecurityCard = ({ term, name, currency }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation('markets');

  const COLOR_MAP = {
    EQUITY: {
      bg: lighten(theme.palette.equity.light, 0.7),
      fg: theme.palette.equity.main,
    },
    SAFE: {
      bg: lighten(theme.palette.safe.light, 0.7),
      fg: theme.palette.safe.main,
    },
    DEBT: {
      bg: lighten(theme.palette.debt.light, 0.7),
      fg: theme.palette.debt.main,
    },
    CONVERTIBLE: {
      bg: lighten(theme.palette.convertible.light, 0.7),
      fg: theme.palette.convertible.main,
    },
    REVENUE_SHARING: {
      bg: lighten(theme.palette.revenue.light, 0.7),
      fg: theme.palette.revenue.main,
    },
    OTHER: {
      bg: lighten(theme.palette.greyScale.light, 0.7),
      fg: theme.palette.greyScale.dark,
    },
    UNKNOWN: {
      bg: lighten(theme.palette.greyScale.light, 0.7),
      fg: theme.palette.greyScale.dark,
    },
  };
  const classes = useStyles({
    fg: COLOR_MAP[name].fg,
    bg: COLOR_MAP[name].bg,
  });

  return (
    <div className={classes.root}>
      <Spacer spacing={2} />
      <Typography variant="subheader" className={classes.termTitle}>
        {t(`markets.detailView.security.${name}` as const).toUpperCase()}
      </Typography>
      <Spacer spacing={1} />

      {Object.keys(term!).map((key) => {
        const value = term[key];
        return (
          <Box
            key={key}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            style={{ marginBottom: theme.spacing(1) }}
          >
            {key !== 'name' && (
            <>
              <Typography variant="base2regular">{t(`markets.detailView.terms.${key}` as const)}</Typography>
              <Typography variant="baseBold" className={classes.termValueText}>
                {useTermsFormat(key, value, currency)}
              </Typography>
            </>
            )}
          </Box>
        );
      })}
      <Spacer spacing={1} />
      {/* {security.bottomText && (
        <Typography variant="small2">{security.bottomText}</Typography>
        <Spacer spacing={1} />
      )} */}

    </div>
  );
};

SecurityCard.defaultProps = (defaultProps as unknown) as Partial<Props>;

export default SecurityCard;
